import styled from "styled-components";
import { useEffect } from "react";

import amuur from "../../assets/imagens/logosClientes/amuur.webp";
import beato from "../../assets/imagens/logosClientes/beato.webp";
import bellacitta from "../../assets/imagens/logosClientes/bellacitta.webp";
import brauni from "../../assets/imagens/logosClientes/brauni.webp";
import coxinhas from "../../assets/imagens/logosClientes/coxinhas.webp";
import desfihas from "../../assets/imagens/logosClientes/desfihas.webp";
import donanita from "../../assets/imagens/logosClientes/donanita.webp";
import estoril from "../../assets/imagens/logosClientes/estoril.webp";
import nho from "../../assets/imagens/logosClientes/nho.webp";
import piper from "../../assets/imagens/logosClientes/piper.webp";
import sabordefamilia from "../../assets/imagens/logosClientes/sabordefamilia.webp";
import saikoo from "../../assets/imagens/logosClientes/saikoo.webp";
import togo from "../../assets/imagens/logosClientes/togo.webp";

const imagens = [
  { src: amuur, key: 1, alt: "Amuur" },
  { src: beato, key: 3, alt: "Beato" },
  { src: bellacitta, key: 4, alt: "Bellacitta" },
  { src: brauni, key: 5, alt: "Brauni" },
  { src: coxinhas, key: 6, alt: "Coxinhas" },
  { src: desfihas, key: 7, alt: "D-esfihas" },
  { src: donanita, key: 8, alt: "Donanita" },
  { src: estoril, key: 9, alt: "Estoril" },
  { src: nho, key: 10, alt: "Nho" },
  { src: piper, key: 13, alt: "Piper" },
  { src: sabordefamilia, key: 14, alt: "Sabor de Família" },
  { src: saikoo, key: 15, alt: "Saikoo" },
  { src: togo, key: 16, alt: "Togo" },
];

const Container = styled.div`
  background-color: white;
  border-radius: var(--border-radius-m);
  overflow: hidden;
  width: 85vw;
  display: flex;
  align-self: center;
  max-width: var(--max-section-w);

  @media screen and (min-width: 993px) {
    max-width: 800px;
  }
`;

const LogosContainer = styled.div`
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  position: relative;

  &:before,
  &:after {
    position: absolute;
    top: 0;
    width: 250px;
    height: 100%;
    content: "";
    z-index: 2;
  }
`;

const Logo = styled.img`
  width: 5em;
  height: auto;
  margin: 0.5em 1em;
`;

const Slider = styled.div`
  display: inline-block;
  animation: 25s slide infinite linear;
  overflow: hidden;

  @keyframes slide {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  }
`;

export default function ListaClientes() {
  useEffect(() => {
    window.onload = function () {
      const slider = document.querySelector(".logos-slide");

      if (slider !== null && slider !== undefined) {
        var copy = slider.cloneNode(true);
        document.querySelector(".logos").appendChild(copy);
      }
    };
  });

  return (
    <Container>
      <LogosContainer className="logos">
        <Slider className={"logos-slide"}>
          {imagens.map((x) => {
            return <Logo src={x.src} key={x.key} alt={x.alt} />;
          })}
        </Slider>
        <Slider className={"logos-slide"}>
          {imagens.map((x) => {
            return <Logo src={x.src} key={x.key} alt={x.alt} />;
          })}
        </Slider>
      </LogosContainer>
    </Container>
  );
}
